export default "/images/img_4.png?f8a26b13d682a4e540c871b0c248266c";